"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_helmet_1 = require("react-helmet");
const MaintenanceMobileSubLinks_1 = __importDefault(require("@Components/MaintenanceMobileSubLinks"));
const mobx_react_1 = require("mobx-react");
const navigation_1 = __importDefault(require("@App/navigation"));
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
const RightsholderContactTable_1 = __importDefault(require("@Components/RightsholderContact/RightsholderContactTable"));
const permissions_1 = require("@Const/permissions");
const common_1 = require("@Const/common");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const RightsholderContactListContentHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderContactList/RightsholderContactListContentHeader"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const RightsholderContactList = () => {
    const { uiStore, contactStore, preloaderStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const getData = () => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        const currentRightsHolderId = rightsholderStore.currentRightsholderId;
        const contactList = contactStore.rightsholderContacts;
        if ((contactList === null || contactList === void 0 ? void 0 : contactList.data) && (contactList === null || contactList === void 0 ? void 0 : contactList.count) > 0) {
            const isAllContactsForCurrentRightsholder = contactList.data.every((contact) => contact.ipId === currentRightsHolderId);
            if (!isAllContactsForCurrentRightsholder) {
                yield contactStore.loadRightsholderContacts();
            }
        }
        else {
            yield contactStore.loadRightsholderContacts();
        }
        preloaderStore.openTransparentPreloader(false);
    });
    const isMobile = uiStore.isMobile;
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_contact_list');
        getData().then();
    }, []);
    const rightsholderContacts = contactStore.rightsholderContacts;
    if (!rightsholderContacts) {
        return null;
    }
    const blueBoxTitle = 'Contact' + (rightsholderContacts.count !== 1 ? 's' : '');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: 'Contacts' }),
        react_1.default.createElement("div", { className: "rightsholder-contact-list-wrapper" },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement("div", { className: "head-block" },
                    react_1.default.createElement(ContentHeader_1.default, { title: 'Contacts', descriptionElement: react_1.default.createElement(RightsholderContactListContentHeader_1.default, null) },
                        react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address], orIsInternal: true },
                            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', className: 'add-contact-button', typeLink: true, icon: common_1.ICONS.add, linkTo: navigation_1.default.rightholder.maintenance.contactInformation(rightsholderStore.currentRightsholderId, 'new') }, "Add Contact")))),
                isMobile && react_1.default.createElement(MaintenanceMobileSubLinks_1.default, null),
                react_1.default.createElement("div", { className: "blue-box-line-header" },
                    react_1.default.createElement("h5", null,
                        rightsholderContacts.count,
                        " ",
                        blueBoxTitle)),
                react_1.default.createElement("section", { className: 'items-container' }, rightsholderContacts.count > 0 ? (react_1.default.createElement(RightsholderContactTable_1.default, { rightsholderContacts: rightsholderContacts.data })) : (react_1.default.createElement("p", { className: 'small no-results' }, "You currently have no contacts")))))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderContactList);
